'use client';

import { c as _c } from "react/compiler-runtime";
import { Layout, LayoutSection } from '@petsmart-ui/sparky';
import { Header } from '@/components/Header/Header';
import Menu from '@/components/Menu/Menu';
import { useTokenValidator } from '@/hooks';
import type { LayoutWrapperProps } from '@/types';
import './layoutWrapper.scss';
export default function LayoutWrapper(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  useTokenValidator();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Header />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LayoutSection className="layout-wrapper__sidebar"><Menu /></LayoutSection>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <>{t1}<Layout variant="left-sidebar" className="layout-wrapper__container">{t2}<LayoutSection className="layout-wrapper__content">{children}</LayoutSection></Layout></>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}